import React, { useState, useEffect } from 'react';
import { Window } from "@progress/kendo-react-dialogs";
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Link } from 'react-router-dom';

const MoreDetailsWindow = ({jobID, closeWindow}) => {
    const [windowStage, setWindowStage] = useState("DEFAULT");
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const [error, setError] = useState('');

    const handleStageChange = (e) => {
        setWindowStage(e.state);
        if(e.state === "MINIMIZED") {
            closeWindow()
        }
    };

    useEffect(async () => {
        if(jobID) {
            var details = await api.GetUpdateHistory(jobID).then(data => {
                return data
            }).catch(error => {
              console.log(error) // todo add better logging / error handing
            })
            if(!details) {
                setError('Unable to retrieve more details')
            }
            if(details && !details.length) {
                setError('No Details Found')
            }
            if(details && details.length) {
                let cleanedDetails = details.map(detail => ({
                    ...detail,
                    name: `${detail.firstName} ${detail.lastName}`,
                    ids: `${detail.personID} ${detail.osuIdmID} ${detail.workforceID}`
                }))
                setDetails(cleanedDetails)
            }
        }
        setLoading(false)
    }, [])

    const nameCell = (props) => {
        let url = ''
        if(props.dataItem.workforceID && props.dataItem.workforceID.length && props.dataItem.workforceID != 'null') {
            url=`/Users?workforceid=${props.dataItem.workforceID}`
        } else if(props.dataItem.osuIdmID && props.dataItem.osuIdmID.length && props.dataItem.osuIdmID != 'null') {
            url=`/Users?osuidmid=${props.dataItem.osuIdmID}`
        } else if(props.dataItem.personID && props.dataItem.personID.length && props.dataItem.personID != 'null') {
            url=`/Users?personid=${props.dataItem.personID}`
        }
        return (
          <td {...props.tdProps} >
            {url.length ? <Link to={url}>{props.dataItem.firstName} {props.dataItem.lastName}</Link> : `${props.dataItem.firstName} ${props.dataItem.lastName}`}
          </td>
        );
    };


    const DetailComponent = (props) => {
        const dataItem = props.dataItem;
        return (
            <section>
                <div>
                    <strong>Changed:</strong> {dataItem.fieldChanged}
                </div>
                <div>
                    <strong>From:</strong> {dataItem.updatedFrom}
                </div>
                <div>
                    <strong>To:</strong> {dataItem.updatedTo}
                </div>
            </section>
        );
    };

    const expandChange = (event) => {
        let newData = details.map((item) => {
            if (item.historyID === event.dataItem.historyID) {
                item.expanded = !event.dataItem.expanded;
            }
            return item;
        });
        setDetails(newData);
    };

    return (
        <Window title={`More Details for Job: ${jobID}: Records: ${details.length ?? 0}`} 
            initialHeight={500} 
            initialWidth={800} 
            initialTop={window.scrollY + 50}
            stage={windowStage} 
            onStageChange={handleStageChange} 
            onClose={closeWindow}>
            {loading && <span><Loader className='spinner-small' size="small" type={"infinite-spinner"} /> Loading Job Details</span>}
            {error.length 
                ? <p className='warning'>{error}</p>
                :  <div>
                    {/* USE DETAIL ROWS FOR MORE USER INFO?? */}
                    <Grid data={details}
                        detail={DetailComponent}
                        expandField="expanded"
                        onExpandChange={expandChange}>
                        <GridColumn  width={200} field="name" title="Name" cell={nameCell} />
                        <GridColumn width={160} field="ids" title="IDs"/>
                        <GridColumn width={130} field="actionDone" title="Action" />
                        <GridColumn field="notes" title="Notes" />
                    </Grid>
                </div>
            }
        </Window>
    );
};

export default MoreDetailsWindow